export default {
  loading: "拼命加载中",
  totalData: "条数据",
  totalPrefix: "共计",
  download: "下载",
  downloadDetails: "下载数据明细",
  noData: "暂无数据",
  columns: {
    direction: "交易方向",
    totalCount: "交易次数",
    currency: "币种",
    totalQuantity: "交易总数量",
  },
  directions: {
    buy: "买入",
    sell: "卖出",
    unknown: "未知",
  },
};
